import { useQuery } from '@tanstack/react-query';

import { Transit } from '@e-origin/shared';

import { showErrorToast } from '@hooks/showErrorToast';
import { apiClient } from '@utils';

export const useTransit = (id: string) =>
  useQuery({
    queryKey: ['transit', id],
    queryFn: async (): Promise<Transit> => {
      try {
        const result = await apiClient.transit.retrieveTransit.query({ params: { id } });
        if (result.status !== 200) throw result.body;
        return result.body.data.transit as unknown as Transit;
      } catch (error) {
        showErrorToast(error, 'Failed to fetch transit details');
      }
    },
    enabled: !!id,
  });
